import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import IconScreen from '../../../../resources/img/icons/films.png'
import InfoBox from '../../../InfoBox'

const LatestPlaylist = ({ name, isEmpty, loading, t }) => (
    <InfoBox isEmpty={isEmpty} loading={loading} title={t('Latest Playlist')} value={name} img={IconScreen} />
)

LatestPlaylist.propTypes = {
    name: PropTypes.string,
    isEmpty: PropTypes.bool,
    loading: PropTypes.number,
    t: PropTypes.func.isRequired,
}

LatestPlaylist.defaultProps = {
    name: '',
    isEmpty: true,
    loading: null,
}

export default withTranslation()(LatestPlaylist)
